import { useSettings, useStore } from '../context/store';

export default function useUpdateFilter() {
    const {
        state,
        dispatch,
    } = useStore();

    const updateFilter = function( field, value, type = 'multiselect' ) {
        dispatch({ 
            type: 'setFilter', 
            payload: { 
                'field': field, 
                'value': value 
            } 
        })
    }

    return {
        updateFilter
    }
}